import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import axios from "axios";
import config from "../config";
import Field from "../sections/MUI/Field";
import InfiniteScroll from "react-infinite-scroller";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";
import Icon from "../sections/MUI/Icon";

class Users extends Component {

    state = {
        users: [],
        page: 1,
        hasNextPage: true,
        totalPages: null,

        search: "",

        boxAdd: false,

        firstName: "",
        lastName: "",
        gender: "مرد",
        phoneNumber: ""
    };


    getUsers(page, search = "") {
        axios.get(`${config.api}/admin/users?token=${config.token}&page=${page}&search=${search}`)
            .then(r => {
                const users = r.data.result;

                this.setState({
                    users: page > 1 ? [...this.state.users, ...users.docs] : users.docs,
                    page: page + 1,
                    hasNextPage: users.hasNextPage,
                    totalPages: users.totalPages
                });
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    delete(id) {
        toast.info("در حال ثبت ...");
        axios.delete(`${config.api}/admin/user?token=${config.token}&id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد.");
                this.getUsers(1, this.state.search);
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    submit() {
        const {firstName, lastName, phoneNumber, gender} = this.state;
        if (firstName.toString().trim() !== "" && lastName.toString().trim() !== "" && phoneNumber.toString().trim().length === 11) {
            let params = new URLSearchParams();
            params.append("firstName", firstName);
            params.append("lastName", lastName);
            params.append("phoneNumber", phoneNumber);
            params.append("gender", gender);


            axios.post(`${config.api}/admin/user?token=${config.token}`, params)
                .then(r => {
                    toast.success("با موفقیت ثبت شد");
                    this.getUsers(1, this.state.search)
                    this.setState({
                        firstName: "",
                        lastName: "",
                        gender: "مرد",
                        phoneNumber: ""
                    });
                })
                .catch(err => {
                    config.handleError(err);
                });
        } else {
            toast.error("همه فیلد ها را کامل کنید")
        }
    }

    render() {
        const {
            users, page, hasNextPage, search, boxAdd,
            firstName, lastName, gender, phoneNumber
        } = this.state;
        return (
            <div className="users">
                <Back {...this.props}/>

                <div className="row">
                    <div className="col-md-5">
                        <Button submit={false} icon="plus" onClick={() => this.setState({boxAdd: !boxAdd})}>ثبت
                            کاربر</Button>
                    </div>
                </div>
                {boxAdd ?
                    <div className="row add-user">
                        <div className="col-md-6">
                            <Field name="firstName"
                                   value={firstName}
                                   label="نام"
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                        </div>
                        <div className="col-md-6">
                            <Field name="lastName"
                                   value={lastName}
                                   label="نام خانوادگی"
                                   onChange={(name, value) => this.setState({[name]: value})}/>

                        </div>

                        <div className="col-md-6">
                            <Field name="phoneNumber"
                                   value={phoneNumber}
                                   label="شماره موبایل"
                                   maxLength={11}
                                   style={{direction: "ltr"}}
                                   onChange={(name, value) => this.setState({[name]: value})}/>

                        </div>
                        <div className="col-md-6">
                            <div className="gender">
                                <div className="row">
                                    <div className="col">
                                        <div className={gender === "مرد" ? "item active" : "item"}
                                             onClick={() => this.setState({gender: "مرد"})}>مرد
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className={gender === "زن" ? "item active" : "item"}
                                             onClick={() => this.setState({gender: "زن"})}>زن
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row justify-content-center">
                                <div className="col-md-5">
                                    <Button submit={false} icon="check"
                                            onClick={() => this.submit()}>ثبت کردن</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                <br/>
                <div className="row justify-content-center">
                    <div className="col-md-7">
                        <Field name="search"
                               value={search}
                               label="جستجو"
                               onChange={(name, value) => {
                                   this.setState({[name]: value});
                                   this.getUsers(1, value);
                               }}/>
                    </div>

                </div>


                <br/>
                <div className="list">
                    <InfiniteScroll
                        pageStart={1}
                        loadMore={() => this.getUsers(page, search)}
                        hasMore={hasNextPage}
                        loader={<div className="loader" key={0}>دریافت ...</div>}>
                        {
                            users ? users?.map((u, i) =>
                                    <article key={"user" + i}>
                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col-auto">
                                                        <div className="code"
                                                             onClick={() => this.props.navigate(`/user/${u.id}`)}>#{u.code}</div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="full-name"
                                                             onClick={() => this.props.navigate(`/user/${u.id}`)}>
                                                            <span>{u.firstName}</span><span>{u.lastName}</span></div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="phone-number"
                                                             onClick={() => this.props.navigate(`/user/${u.id}`)}>{u.phoneNumber}</div>
                                                    </div>
                                                </div>

                                                <div className="orders"><span>تعداد سفارشات:</span><span>{u.orders}</span>
                                                </div>

                                                <div className="created-at">{u.createdAt}</div>
                                            </div>
                                            <div className="col-auto">
                                                <Icon i="trash" className="delete-icon" onClick={() => this.delete(u.id)}/>
                                            </div>
                                        </div>


                                    </article>)
                                : null
                        }
                    </InfiniteScroll>
                </div>
            </div>
        );
    }
}

export default gpn(Users);